import { Location } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
declare const Swal

@Component({
  selector: 'app-single-view-vendor',
  templateUrl: './single-view-vendor.component.html',
  styles: [
    `  .card{
            border:none;
            cursor:pointer;
            padding:10px;
        }
       
        .ft-colr{
            color:#808080b3;
        }
    `]
})
export class SingleViewVendorComponent {

  public breadcrumbData = {
    "Information": "/organization/transport-manager/information",
    "Vendors": "/organization/transport-manager/information/vendor/view-vendor",
    "View": '',
  };

  vendorViewData: any = {};
  vendorViewKeys = [];
  headerName: any;
  orgID: string;
  vendorID: string;

  public totalVehicle = 0;
  public activeVehicle = 0;
  public inActiveVehicle = 0;
  public totalDriver = 0;
  public activeDriver = 0;
  public inActiveDriver = 0;

  public assignedVehicles = 0;
  public unassignedVehicles = 0;
  public unassignedDrivers = 0;


  constructor(public storage: StorageService, public router: Router,
    public location: Location,
    public route: ActivatedRoute,
    public api: ApiService,
    public swal: SweetAlert,
  ) {
    this.route.paramMap.subscribe((params: any) => {
      this.vendorID = params.params.vendorID;
    });
    this.orgID = this.storage.get('userInfo').orgID;
  }
  ngOnInit() {
    this.headerName = this.vendorViewData.vendorName;
    this.getVendorData();
  }
  // ngOnDestroy() {
  //     this.storage.remove('vendorViewData')
  // }
  getVendorData() {
    const obj = {
      orgID: this.orgID,
      vendorID: this.vendorID
    };
    this.api.transportManagerVendorList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.vendorViewData = res.data[0];
        if (this.vendorViewData.vendorName){
          delete this.breadcrumbData['View'];
          this.breadcrumbData[this.vendorViewData.vendorName] = '';
        }
        if (res.vehicles) {
          if (res.vehicles.all) this.totalVehicle = res.vehicles.all;
          if (res.vehicles.active) this.activeVehicle = res.vehicles.active;
          if (res.vehicles.inActiveVeh) this.inActiveVehicle = res.vehicles.inActiveVeh;
        }
        if (res.dirvers) {
          if (res.dirvers.all) this.totalDriver = res.dirvers.all;
          if (res.dirvers.active) this.activeDriver = res.dirvers.active;
          if (res.dirvers.inActiveVeh) this.inActiveDriver = res.dirvers.inActiveVeh;
        }
        if (res.manage) {
          if (res.manage.assigned) this.assignedVehicles = res.manage.assigned;
          if (res.manage.unassignedDriver) this.unassignedDrivers = res.manage.unassignedDriver;
          if (res.manage.unassignedVehicle) this.unassignedVehicles = res.manage.unassignedVehicle;
        }
      }
    }).catch((err) => {
      console.log(err);
    });
  }


  onclick(val, data) {
    this.storage.setData({ vendorsIdOrgId: data });
    if (val == 'vehicle') {
      this.router.navigate(['/organization/transport-manager/information/vehicle/view-vehicle', data.vendorID]);
    }
    if (val == 'driver') {
      this.router.navigate(['/organization/transport-manager/information/driver/view-driver', data.vendorID]);
    }
    if (val == 'manage') {
      this.router.navigate(['/organization/transport-manager/information/manage/view-manage', data.vendorID]);
    }
  }
  vendorAction(e, item) {
    if (e == 'edit') {
      this.router.navigate(['/organization/transport-manager/information/vendor/edit-view-vendor', item.vendorID]);
    } else if (e == 'delete') {
      console.log(e, item);
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to delete this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',//'#3085d6',
        //  cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          console.log('delete click');
          let obj = { vendorID: item['vendorID'], forceDelete: false };
          this.deleteVendeData(obj);
        }
      });
    }
  }

  deleteVendeData(val?) {

    const obj = {
      orgID: this.storage.get('userInfo').orgID,
      vendorID: val.vendorID,
      forceDelete: val['forceDelete'],
    };

    this.api.transportManagerVendorDelete(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        this.router.navigate(['/organization/transport-manager/information/vendor/view-vendor']);

      }
      else if (res.status == 'failure') {
        this.forceDelete('warning', res.message, val['vendorID']);
        // this.swal.swalFunction('error', res.status, res.message, 3000);
      }
      else {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  forceDelete(Icon: any, Text: any, id) {
    Swal.fire({
      title: 'Are you sure?',
      text: Text,
      icon: Icon.toLowerCase(),
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: 'Force delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        let obj = { vendorID: id, forceDelete: true };
        this.deleteVendeData(obj);
      }
    });
  }
}


// .card:hover{
//     background-color:#0000ff24
// }
// .bgHover:hover{
//     background-color:#0000ff24
// }